// src/pages/Public/LandingPage/v2/components/LanguageSwitcher/LanguageSwitcher.js
//
// Selector de idioma de la landing (ES / EN / FR). Banderas SVG inline (reales, nitidas
// en cualquier SO, sin assets externos ni emojis de bandera —que Windows no renderiza—).

import React from "react";
import { useLandingLang } from "../../i18n/LandingLangContext";

// Banderas SVG (viewBox normalizado). GB = Union Jack estandar.
const FLAGS = {
  es: (
    <svg viewBox="0 0 24 16" width="100%" height="100%" aria-hidden="true">
      <rect width="24" height="16" fill="#AA151B" />
      <rect y="4" width="24" height="8" fill="#F1BF00" />
    </svg>
  ),
  en: (
    <svg viewBox="0 0 60 30" width="100%" height="100%" aria-hidden="true">
      <clipPath id="revi-uk-s">
        <path d="M0,0 v30 h60 v-30 z" />
      </clipPath>
      <clipPath id="revi-uk-t">
        <path d="M30,15 h30 v15 z v15 h-30 z h-30 v-15 z v-15 h30 z" />
      </clipPath>
      <g clipPath="url(#revi-uk-s)">
        <path d="M0,0 v30 h60 v-30 z" fill="#012169" />
        <path d="M0,0 L60,30 M60,0 L0,30" stroke="#fff" strokeWidth="6" />
        <path
          d="M0,0 L60,30 M60,0 L0,30"
          clipPath="url(#revi-uk-t)"
          stroke="#C8102E"
          strokeWidth="4"
        />
        <path d="M30,0 v30 M0,15 h60" stroke="#fff" strokeWidth="10" />
        <path d="M30,0 v30 M0,15 h60" stroke="#C8102E" strokeWidth="6" />
      </g>
    </svg>
  ),
  fr: (
    <svg viewBox="0 0 24 16" width="100%" height="100%" aria-hidden="true">
      <rect width="8" height="16" fill="#0055A4" />
      <rect x="8" width="8" height="16" fill="#FFFFFF" />
      <rect x="16" width="8" height="16" fill="#EF4135" />
    </svg>
  ),
};

const LABELS = { es: "Español", en: "English", fr: "Français" };

export function LanguageSwitcher({ size = 28, className = "", onSelect }) {
  const { lang, setLang, langs } = useLandingLang();

  const handleSelect = (code) => {
    setLang(code);
    if (typeof onSelect === "function") onSelect(code);
  };

  return (
    <div
      className={`flex items-center gap-2 ${className}`}
      role="group"
      aria-label="Selector de idioma"
    >
      {langs.map((code) => {
        const active = lang === code;
        return (
          <button
            key={code}
            type="button"
            onClick={() => handleSelect(code)}
            aria-label={LABELS[code]}
            aria-pressed={active}
            title={LABELS[code]}
            className={`rounded-full overflow-hidden border-2 transition-all cursor-pointer p-0 ${
              active
                ? "border-sky-500 scale-110 opacity-100 shadow-sm"
                : "border-transparent opacity-50 hover:opacity-90"
            }`}
            style={{
              width: size,
              height: size,
              background: "transparent",
              lineHeight: 0,
              display: "inline-flex",
            }}
          >
            {FLAGS[code]}
          </button>
        );
      })}
    </div>
  );
}
